// Build-time configuration loader
// This replaces the runtime config system with build-time tenant configuration

export const loadBuildTimeConfig = () => {
  // Load tenant-specific config from build-time environment variables
  // In production build, tenant configs are embedded at build time via environment variables
  
  // Parse tenant config from environment variable (set by build script)
  const tenantConfigStr = process.env.REACT_APP_TENANT_CONFIG || '{}';
  
  try {
    const config = JSON.parse(tenantConfigStr);
    return config;
  } catch (error) {
    console.error('Failed to parse tenant config:', error);
    // Fallback to default config
    return {
      tenantId: 'default',
      api: {
        baseUrl: process.env.REACT_APP_API_BASE_URL || ''
      },
      branding: {
        name: "Default",
        fullName: "Default Organization",
        shortName: "Default"
      },
      features: {
        dashboard: true,
        offers: true,
        services: true,
        surety: true,
        feedback: true,
        profile: true
      }
    };
  }
};

import { getLanguageConfig } from '../i18n/translations';

export const getBuildTimeBranding = (language = 'en') => {
  const config = loadBuildTimeConfig();
  const langConfig = getLanguageConfig(language);
  
  // Use language-specific branding if available, fallback to default
  // Keys are camelCase: fullNameTe, shortNameTe (not fullNameTE)
  const langSuffix = langConfig.code.charAt(0).toUpperCase() + langConfig.code.slice(1).toLowerCase();
  const shortNameKey = `shortName${langSuffix}`;
  const fullNameKey = `fullName${langSuffix}`;
  
  return {
    shortName: config.branding[shortNameKey] || config.branding.shortName,
    fullName: config.branding[fullNameKey] || config.branding.fullName,
    logoSize: config.branding.logoSize || {}
  };
};

export const getBuildTimeFeatures = () => {
  const config = loadBuildTimeConfig();
  return config.features;
};

export const getBuildTimeApi = () => {
  const config = loadBuildTimeConfig();
  return config.api;
};

export const getBuildTimeSeo = () => {
  const config = loadBuildTimeConfig();
  return config.seo;
};

export const getBuildTimePwa = () => {
  const config = loadBuildTimeConfig();
  return config.pwa;
};

export const getBuildTimeContact = () => {
  const config = loadBuildTimeConfig();
  return config.contact;
};

export default loadBuildTimeConfig;
